import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ConfiguracionCanalFlujoVentaPaso } from '../_models/configuracion-canal-flujo-venta-paso';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionCanalFlujoVentaPasoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/configuracionesCanalesFlujoVentaPasos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso[] ) );
  }

  listadoPorId( idConfigCanal: string ) {
    return this.httClient.get( this.rutServicio + '/configuracionCanal/' + idConfigCanal ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso[] ) );
  }

  listadoHabilitadosPorId( idConfigCanal: string ) {
    return this.httClient.get( this.rutServicio + '/configuracionCanal/' + idConfigCanal + '/enabled' ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso ) );
  }


  crear( regCrear: ConfiguracionCanalFlujoVentaPaso ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso ) );
  }

  actualizar( regActualizar: ConfiguracionCanalFlujoVentaPaso ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regCrear: ConfiguracionCanalFlujoVentaPaso[] ) {
    const auditUser = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.forEach( pc => {
      pc.auditoriaUsuario = auditUser;
    });
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as ConfiguracionCanalFlujoVentaPaso[] ) );
  }
}
